export const STATE_NAME = 'PARTNER_PROGRAM';

export const PREFIX = `${STATE_NAME}_`;

export const UPDATE_FILTERS = PREFIX + 'UPDATE_FILTERS';

export const UPDATE_DIVIDEND_PAYOUTS_FILTERS =
  PREFIX + 'UPDATE_DIVIDEND_PAYOUTS_FILTERS';

export const RESET_DIVIDEND_PAYOUTS_FILTERS =
  PREFIX + 'RESET_DIVIDEND_PAYOUTS_FILTERS';

export const EMAILS_ACCESS_PROCESS_DIVIDEND_PAYOUTS = {
  production: [
    'beth@boulderstrategiesllc.com',
    'nick@boulderstrategiesllc.com',
  ],
  development: ['admin@yopmail.com'],
  uat: ['admin@yopmail.com'],
};

export const CUSTOMER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'InActive',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
};

export const CUSTOMER_STATUS_OPTIONS = [
  {
    id: null,
    name: 'All',
  },
  {
    id: CUSTOMER_STATUS.ACTIVE,
    name: 'Active',
  },
  {
    id: CUSTOMER_STATUS.INACTIVE,
    name: 'Inactive',
  },
  {
    id: CUSTOMER_STATUS.APPROVED,
    name: 'Approved',
  },
  {
    id: CUSTOMER_STATUS.REJECTED,
    name: 'Rejected',
  },
  {
    id: CUSTOMER_STATUS.PENDING,
    name: 'Pending',
  },
];
